import { IconButton, List, ListItem, ListItemButton, ListItemText, TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { GuarantorTablePropsType } from "../../../types/container.type";
import MoreVertIcon from '@mui/icons-material/MoreVert';

export const GuarantorTable: React.FC<GuarantorTablePropsType> = ({ rows, handleEllipsisButtonClick, handleActionItemClick, selectedGuarantor, dropdownRef }) => {
    const actions = ["Edit", "Delete"];
    const guarantorTableHeaders = ["Name", "Phone Number", "Email", "Action"];

    return (
        <BaseTable headers={guarantorTableHeaders}>
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>
                                {`${row?.firstName?.charAt(0).toUpperCase() + row?.firstName?.slice(1)} ${row?.lastName?.charAt(0).toUpperCase() + row?.lastName?.slice(1)}`}
                            </TableCell>
                            <TableCell>{row?.primaryPhone}</TableCell>
                            <TableCell>{row?.email}</TableCell>
                            <TableCell>
                                <IconButton
                                    sx={{
                                        borderRadius: "0.5rem",
                                        backgroundColor: "var(--sky-blue-color)",
                                        "&:hover": {
                                            backgroundColor: "var(--sky-blue-color)"
                                        }
                                    }}
                                    onClick={(e) => handleEllipsisButtonClick(e, row)}
                                >
                                    <MoreVertIcon
                                        sx={{
                                            color: "#FFFFFF",
                                            display: "inline-flex",
                                        }}
                                    />
                                </IconButton>
                                {(selectedGuarantor?.id && selectedGuarantor?.id === row?.id) && (
                                    <List
                                        component={"ul"}
                                        ref={dropdownRef}
                                        className="dropdown-modal"
                                    >
                                        {actions.map((action, index) => (
                                            <ListItem
                                                key={index}
                                                onClick={(e) => handleActionItemClick(e, selectedGuarantor?.id, action)}
                                            >
                                                <ListItemButton>
                                                    <ListItemText
                                                        primary={action}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                    </List>
                                )}
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}
